{
  "name": "webdriver",
  "version": "7.31.1",
  "description": "A Node.js bindings implementation for the W3C WebDriver and Mobile JSONWire Protocol",
  "author": "Christian Bromann <mail@bromann.dev>",
  "homepage": "https://github.com/webdriverio/webdriverio/tree/main/packages/webdriver",
  "license": "MIT",
  "main": "./build",
  "engines": {
    "node": ">=12.0.0"
  },
  "types": "./build/index.d.ts",
  "typeScriptVersion": "3.8.3",
  "repository": {
    "type": "git",
    "url": "git://github.com/webdriverio/webdriverio.git"
  },
  "keywords": [
    "webdriver"
  ],
  "bugs": {
    "url": "https://github.com/webdriverio/webdriverio/issues"
  },
  "devDependencies": {
    "@types/lodash.merge": "^4.6.6"
  },
  "dependencies": {
    "@types/node": "^18.0.0",
    "@wdio/config": "7.31.1",
    "@wdio/logger": "7.26.0",
    "@wdio/protocols": "7.27.0",
    "@wdio/types": "7.30.2",
    "@wdio/utils": "7.30.2",
    "got": "^11.0.2",
    "ky": "0.30.0",
    "lodash.merge": "^4.6.1"
  },
  "gitHead": "9fdf0b6936aadd2b1f2f715ffe024f976287cc56"
}
